module.exports = __webpack_public_path__ + "media/images/admin/icons/chevrons-down-16db08d1348acd7058b6542f32a389f5.svg";